import { http } from '../shared/api';
export const loginApi = (email, password) =>
  http.post('/api/auth/login', { email, password }, { skipAuthRedirect: true });

export const ssoLoginApi = (microsoftAccessToken) =>
  http.post('/api/auth/sso-login', { access_token: microsoftAccessToken }, { skipAuthRedirect: true });

export const changePasswordApi = ({ old_password, new_password, confirm_new_password }) =>
  http.post('/api/auth/change-password', { old_password, new_password, confirm_new_password });

// ── Categories ─────────────────────────────────

export function fetchCategories({ activeOnly = false } = {}) {
  const params = {};
  if (activeOnly) params.active_only = true;
  return http.get('/api/categories', { params });
}

export const fetchCategory = (categoryId) => http.get(`/api/categories/${categoryId}`);
export const fetchCategoryByUserId = (userId) => http.get(`/api/categories/by-user/${userId}`);
export const createCategory = (data) => http.post('/api/categories', data);
export const updateCategory = (id, data) => http.put(`/api/categories/${id}`, data);
export const deleteCategory = (id) => http.delete(`/api/categories/${id}`);

export const adminFetchCategories = fetchCategories;
export const adminCreateCategory = createCategory;
export const adminUpdateCategory = updateCategory;
export const adminDeleteCategory = deleteCategory;

/** Normal-user: categories visible to a specific user */
export const getUserCategories = (userId) => fetchCategoryByUserId(userId);

// ── Statuses ───────────────────────────────────

export const fetchStatuses = () => http.get('/api/statuses');

// ── Roles ──────────────────────────────────────

export const fetchRoles = () => http.get('/api/roles');

// ── Users ──────────────────────────────────────

export const fetchUsers = () => http.get('/api/users');
export const createUser = (data) => http.post('/api/users', data);
export const updateUser = (id, data) => http.put(`/api/users/${id}`, data);
export const resetUserPassword = (id, newPassword) =>
  http.put(`/api/users/${id}/password`, { new_password: newPassword });
